

function authenticationCheck(cognitoSession) {
  const userGroups = cognitoSession.tokens.accessToken.payload['cognito:groups'] || [];
  if (userGroups.includes('initio-admins')||userGroups.includes('redwoodseed-admins')) return true;
  if (userGroups.includes('unified-users')) 
    {
      localStorage.setItem('unifiedUser', 'true');
      return true;
    } 
  
  return false;
}

function parseUserAttributes(cognitoAttributes) {
  const parsedAttributes = {};

  Object.keys(cognitoAttributes).forEach((attributeName) => {
    if (attributeName === 'sub') parsedAttributes.userId = cognitoAttributes[attributeName];
    else parsedAttributes[attributeName.replaceAll('custom:', '')] = cognitoAttributes[attributeName];
  });

  return parsedAttributes;
}

function getUserId() {
  try {
    return localStorage.getItem('userId') || 'admin-preview-user';
  } catch (e) {
    return 'admin-preview-user';
  }
}

function getUserName() {
  try {
    return localStorage.getItem('userName') || 'Admin Preview';
  } catch (e) {
    return 'Admin Preview';
  }
}

export { authenticationCheck, parseUserAttributes, getUserId, getUserName };
